import React from 'react';
import { RichCommentInputProps } from './types';
import useRichCommentInput from './useRichCommentInput';
import styles from './RichCommentInput.module.css';

/**
 * リッチテキスト入力用コンポーネント
 * メンション機能、URLリンク変換、タイムスタンプ機能をサポート
 */
const RichCommentInput: React.FC<RichCommentInputProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  id,
  style,
  disabled = false,
  onSeekToTime
}) => {
  const {
    divRef,
    handleInput,
    handleKeyDown,
    handleFocus,
    handleCompositionStart,
    handleCompositionEnd,
    renderUserSuggestions
  } = useRichCommentInput({
    value,
    onChange,
    onSubmit,
    disabled,
    onSeekToTime
  });

  return (
    <div className={styles['rich-comment-input__container']}>
      <div
        ref={divRef as React.RefObject<HTMLDivElement>}
        id={id}
        contentEditable={!disabled}
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        onClick={() => !disabled && divRef.current?.focus()}
        onFocus={handleFocus}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
        data-placeholder={placeholder}
        className={styles['rich-comment-input__editor']}
        style={style}
        tabIndex={disabled ? -1 : 0}
        data-testid="rich-comment-input__editor"
      />
      
      {/* ユーザーサジェスト */}
      {renderUserSuggestions()}
    </div>
  );
};

export default RichCommentInput; 